<template>
  <router-view />
  <NotificationToast />
</template>

<script setup>
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import NotificationToast from './ui/NotificationToast.vue'
import { useNotificationStore } from '../stores/notifications'

// Password reset runs on Rails-rendered pages, which redirect back into the SPA with a
// marker in the query string. Rails flash messages never reach Vue, so this is the only
// place the user gets told that the mail went out, or that the new password took effect.
const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const notifications = useNotificationStore()

watch(
  () => route.query.reset,
  (marker) => {
    if (marker === 'requested') {
      notifications.info(t('auth.reset.requested'))
    } else if (marker === 'done') {
      notifications.success(t('auth.reset.done'))
    } else {
      return
    }

    // Drop the marker, or a refresh replays the toast.
    const query = { ...route.query }
    delete query.reset
    router.replace({ path: route.path, query })
  },
  { immediate: true }
)
</script>
